import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CustomPreloadStrategy } from "@app/app.preload-strategy";
import { PwaAuthGuardService } from "@core/services/guards/pwa-auth-guard.service";

const routes: Routes = [
  {
    path: "",
    loadChildren: () => import("@features/home/home.module").then(m => m.HomeModule),
    canActivate: [PwaAuthGuardService]
  },
  {
    path: "about",
    loadChildren: () => import("@features/about/about.module").then(m => m.AboutModule)
  },
  {
    path: "account",
    loadChildren: () => import("@features/account/account.module").then(m => m.AccountModule)
  },
  {
    path: "dev",
    loadChildren: () => import("@features/dev/dev.module").then(m => m.DevModule)
  },
  {
    path: "equipment",
    loadChildren: () => import("@features/equipment/equipment.module").then(m => m.EquipmentModule),
    canActivate: [PwaAuthGuardService]
  },
  {
    path: "explore",
    loadChildren: () => import("@features/explore/explore.module").then(m => m.ExploreModule),
    canActivate: [PwaAuthGuardService]
  },
  {
    path: "forum",
    loadChildren: () => import("@features/forum/forum.module").then(m => m.ForumModule),
    canActivate: [PwaAuthGuardService]
  },
  {
    path: "i",
    loadChildren: () => import("@features/image/image.module").then(m => m.ImageModule),
    canActivate: [PwaAuthGuardService]
  },
  {
    path: "iotd",
    loadChildren: () => import("@features/iotd/iotd.module").then(m => m.IotdModule),
    canActivate: [PwaAuthGuardService]
  },
  {
    path: "messages",
    loadChildren: () => import("@features/messages/messages.module").then(m => m.MessagesModule),
    data: { preload: true }
  },
  {
    path: "notifications",
    loadChildren: () => import("@features/notifications/notifications.module").then(m => m.NotificationsModule),
    canActivate: [PwaAuthGuardService]
  },
  {
    path: "permission-denied",
    loadChildren: () =>
      import("@features/permission-denied/permission-denied.module").then(m => m.PermissionDeniedModule)
  },
  {
    path: "search",
    loadChildren: () => import("@features/search/search.module").then(m => m.SearchModule),
    data: { preload: true },
    canActivate: [PwaAuthGuardService]
  },
  {
    path: "subscriptions",
    loadChildren: () => import("@features/subscriptions/subscriptions.module").then(m => m.SubscriptionsModule)
  },
  {
    path: "uploader",
    loadChildren: () => import("@features/uploader/uploader.module").then(m => m.UploaderModule),
    canActivate: [PwaAuthGuardService]
  },
  {
    path: "u",
    loadChildren: () => import("@features/users/user.module").then(m => m.UserModule),
    data: { preload: true },
    canActivate: [PwaAuthGuardService]
  },
  {
    path: "**",
    loadChildren: () => import("@features/not-found-404/not-found-404.module").then(m => m.NotFound404Module)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: "reload",
      initialNavigation: "enabledBlocking",
      scrollPositionRestoration: "enabled",
      anchorScrolling: "enabled",
      scrollOffset: [0, 64],
      preloadingStrategy: CustomPreloadStrategy
    })
  ],
  exports: [RouterModule],
  providers: [CustomPreloadStrategy]
})
export class AppRoutingModule {}
